import { configureStore } from "@reduxjs/toolkit";
import snackbarReducer from "./reducers/snackbar";
import isMobileReducer from "./reducers/isMobile";
import themeModeReducer from "./reducers/themeMode";
import isFullscreenReducer from "./reducers/isFullscreen";
import searchReducer from "./reducers/search";
import userReducer from "./reducers/user";
import selectedOrganisationReducer from "./reducers/selectedOrganisation";
import dateRangeReducer from "./reducers/dateRange";
import currentReducer from "./reducers/current";
import pitchReducer from "./reducers/pitch";
import userOrganisationRolesReducer from "./reducers/userOrganisationRoles";
import loadingReducer from "./reducers/loading";

export const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      immutableCheck: false,
      serializableCheck: false,
    }),
  reducer: {
    isFullscreen: isFullscreenReducer,
    isMobile: isMobileReducer,
    search: searchReducer,
    selectedOrganisation: selectedOrganisationReducer,
    snackbar: snackbarReducer,
    themeMode: themeModeReducer,
    user: userReducer,
    dateRange: dateRangeReducer,
    current: currentReducer,
    pitch: pitchReducer,
    userOrganisationRoles: userOrganisationRolesReducer,
    loading: loadingReducer,
  },
});
